import alert from './alert'
import auth from './auth'
import loader from './loader'
import logout from './logout'
import redeem from './redeem'
import userInfo from './user-info'
import sessionModal from './session-modal'
import asapSuccess from './asapSuccess'

export default {
  strict: false,
  namespaced: true,
  state: Object.assign(
    alert.state,
    auth.state,
    loader.state,
    logout.state,
    redeem.state,
    userInfo.state,
    sessionModal.state,
    asapSuccess.state
  ),
  mutations: Object.assign(
    alert.mutations,
    auth.mutations,
    loader.mutations,
    logout.mutations,
    redeem.mutations,
    userInfo.mutations,
    sessionModal.mutations,
    asapSuccess.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/global/index.js